import React, { PureComponent, FC } from 'react';
import ExperimentContext from './Experiment/ExperimentContext';
import { Experiments, UpdateExperiments } from './SharedTypes';

type WhenProps = {
  bucket: string | string[];
  render?: Function;
};

type WhenRegisterProps = WhenProps & {
  context: {
    currentExperiment?: string;
    experiments?: Experiments;
    updateExperiment?: UpdateExperiments;
  };
};

const When: FC<WhenProps> = props => (
  <ExperimentContext.Consumer>
    {context => <WhenRegister context={context} {...props} />}
  </ExperimentContext.Consumer>
);

class WhenRegister extends PureComponent<WhenRegisterProps> {
  componentDidMount() {
    const { bucket } = this.props;

    if (Array.isArray(bucket)) {
      bucket.map(b => this.checkForUpdate(b));
    } else {
      this.checkForUpdate(bucket);
    }
  }

  checkForUpdate = bucket => {
    const {
      context: {
        currentExperiment: name = '', experiments = {}, updateExperiment = () => {}
      }
    } = this.props;
    const { buckets = null } = experiments[name] || {};

    if (buckets && !buckets.includes(bucket)) {
      const previousValues = experiments[name];
      experiments[name] = {
        ...previousValues,
        buckets: buckets.concat([bucket])
      };
      updateExperiment(name, experiments);
    }
  }

  render() {
    const {
      bucket,
      render = null,
      children,
      context: { currentExperiment = '', experiments = {} }
    } = this.props;
    const { isLoading = null, assignedBucket = null } = experiments[currentExperiment] || {};
    const hasBucket =
      Array.isArray(bucket) && bucket && assignedBucket
        ? !!bucket.find(x => x === assignedBucket)
        : assignedBucket === bucket;
    const canRender = hasBucket && !isLoading;
    if (!canRender) return null;

    return (
      <>
        {render ?
          render({ ...experiments[currentExperiment] }) : (
            <>{children}</>
          )
        }
      </>
    );
  }
};

export default When;
